var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meta"},[_c('span',{staticClass:"meta-no"},[_vm._v("#"+_vm._s(_vm.number))]),_c('span',{staticClass:"meta-stats"},[_c('span',[_vm._v("TILES "+_vm._s(_vm.tilesRevealed)+"/16")]),_c('span',{staticClass:"meta-dot"},[_vm._v("·")]),_c('span',[_vm._v("GUESSES "+_vm._s(_vm.guessesUsed)+"/16")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }